export default "__VITE_ASSET__bWzskc$m__"